import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {getMessages,postMessage} from "../../modules/streams";
import 'loaders.css/src/animations/line-scale.scss'
import {traverse} from '../../modules/StateTree';
const Loader = require('react-loaders').Loader;

class Home extends React.Component {
    componentWillMount() {
        this.props.getMessages(this.props.match.params.id)
    }
    getStreams(root) {
        let streams = [];
        traverse(root,(node) => {
            streams.push(<div className={`stream ${node.level >= 2 && "dubb"}`} key={node.id}>
                {
                    node.data.links &&
                    <div className={"innerStream"}>
                        <div className={"author"}>
                            <img alt={node.data.links._author && node.data.links._author.profileImageUrl}
                                 className="authorImage"
                                 src={node.data.links._author && node.data.links._author.profileImageUrl}/>
                            <div className="authorDescription">
                                <div
                                    className={"authorName"}>{node.data.links._author && node.data.links._author.fullName}</div>
                                <div className={"time"}>{node.data.createdDateTime}</div>
                            </div>
                        </div>
                        <div className={"content"}>{node.data.content}</div>
                        {node.data.status === 1 &&<div className={"sendMessage"}>
                            <input id={`messageInput${node.id}`}/>
                             <input type="button" value="Send" onClick={() => {
                                this.props.postMessage(this.props.user, this.props.accounts.find((a) => a._id === this.props.match.params.id), node);
                            }}/>
                        </div>
                        }
                    </div>
                }
            </div>)
        })
        return streams;
    }
    render() {

        let threads = [ ];

        this.props.streams.root && this.props.streams.root.children.map((root,i) => {
            threads.push(<div className={"thread"} key={i}>
            {this.getStreams(root)}</div>);
        })


            return <div>
                <header>
                    <Link to="/home">Home</Link>
                    <Link to="/about-us">About</Link>
                </header>
                <div>
                    {this.props.user.username}
                    <div id={"header"}>
                    </div>
                    {threads.length > 0 ? threads.map((t, i) => <div className="threads" key={i}>{t}</div>) : <Loader color="#ccc" type="line-scale" active key={0} />}
                </div>
            </div>;

    }
}

const mapStateToProps = ({ user,streams,accounts }) => ({
    user,
    streams,
    accounts
})

const mapDispatchToProps = dispatch => bindActionCreators({
    getMessages,
    postMessage
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Home)


// WEBPACK FOOTER //
// ./src/containers/home/messages.js